import Icon from '@ant-design/icons'
import * as React from 'react'

import { NovaIconProps } from '../types/iconTypes'

const Update = (props: NovaIconProps) => (
  <Icon
    {...props}
    component={() => (
      <svg
        width="1em"
        height="1em"
        focusable={false}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M26.1924 4C26.1924 3.44772 25.7447 3 25.1924 3C24.6401 3 24.1924 3.44772 24.1924 4V7.23167C22.0485 5.22796 19.1677 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28C20.0357 28 23.6058 26.0069 25.7795 22.9557C26.1 22.5059 25.9951 21.8815 25.5453 21.561C25.0955 21.2406 24.4711 21.3454 24.1506 21.7952C22.3361 24.3423 19.3616 26 16 26C10.4772 26 6 21.5228 6 16C6 10.4772 10.4772 6 16 6C18.7969 6 21.3257 7.14753 23.1415 9H19.1924C18.6401 9 18.1924 9.44772 18.1924 10C18.1924 10.5523 18.6401 11 19.1924 11H25.1924C25.7447 11 26.1924 10.5523 26.1924 10V4Z"
          fill="currentColor"
        />
      </svg>
    )}
  />
)

export default Update
